/**
 * 2019-04-12
 * handan
 * 调查结果详情
 */

import React, { Component, Fragment } from 'react'
import "./style.scss";
import { getResultDetail, getResultDetailNew } from "../../models";
import moment from "moment";
import stopXSS from "../../utils/stopXSS";

class ResultDetail extends Component{
  constructor(props){
    super(props)
    this.state = {
      data: {},
    }
    this.params = this.props.location.state;
    this.goBack = this.goBack.bind(this);
  }

  cpws(data){
    return (
      <Fragment>
        <p>标题：{data.title}</p>
        <p>法院名称：{data.court}</p>
        <p>判决结果：</p>
        <p dangerouslySetInnerHTML={{__html: stopXSS(data.judgeResult)}}></p>
        <p>内容概要：</p>
        <p dangerouslySetInnerHTML={{__html: stopXSS(data.body)}}></p>
        <p>案号：{data.caseNo}</p>
      </Fragment>
    )
  }

  shixin(data){
    return (
      <Fragment>
        <p>法院名称：{data.court}</p>
        <p>案号：{data.caseNo}</p>
        <p>发布时间：{moment(parseInt(data.postTime)).format("YYYY-MM-DD")}</p>
        <p>立案时间：{moment(parseInt(data.sortTime)).format("YYYY-MM-DD")}</p>
        <p>失信情况：{data.jtqx}</p>
        <p>被执行人履行情况：{data.lxqk}</p>
        <p>内容概要：</p>
        <p dangerouslySetInnerHTML={{__html: stopXSS(data.yiwu)}}></p>
      </Fragment>
    )
  }

  renderJinRong(data){
    const { list = [] } = data ;
    return (
      <Fragment>
        {
          list.map((item)=>{
            return (
              <ul className="jinrong" key={item.url}>
                <li>处罚标题：{ item.title }</li>
                <li>处罚时间：{ item.time }</li>
                <li>详情链接：<a href={ item.url } target="_blank">{ item.url }</a></li>
              </ul>
            )
          })
        }
      </Fragment>
    )
  }

  renderZgzs(data){
    const { list = [] } = data ;
    return (
      <Fragment>
        {
          list.map((item)=>{
            return (
              <ul className="jinrong">
                {
                  item.certName ? <li>职业资格名称：{item.certName}</li> : null 
                }
                {
                  item.certNo ? <li>证书编号：{item.certNo}</li> : null 
                }{
                  item.chineseLevel ? <li>职业认证等级：{item.chineseLevel}</li> : null 
                }{
                  item.numberLevel ? <li>等级：{item.numberLevel}</li> : null 
                }{
                  item.operScore ? <li>操作分数：{item.operScore}</li> : null 
                }{
                  item.sumbitDate ? <li>认证日期：{item.sumbitDate}</li> : null 
                }{
                  item.sumbitUnit ? <li>认证机构：{item.sumbitUnit}</li> : null 
                }{
                  item.textScore ? <li>笔试分数：{item.textScore}</li> : null 
                }
              </ul>
            )
          })
        }
      </Fragment>
    )
  }

  renderShangYe(data){
    const detailItems = {
      "rypos_1": [
        {
          title: "统一社会信用代码：",
          keyName: "creditcode",
        },
        {
          title: "企业(机构)名称：",
          keyName: "entname",
        },
        {
          title: "企业状态：",
          keyName: "entstatus",
        },
        {
          title: "企业(机构)类型：",
          keyName: "enttype",
        },
        {
          title: "成立时间：",
          keyName: "esdate",
        },
        {
          title: "行业名称：",
          keyName: "industryphyname",
        },
        {
          title: "个人标识码：",
          keyName: "palgorithmid",
        },
        {
          title: "注册资本(企业:万元)：",
          keyName: "regcap",
        },
        {
          title: "注册资本币种：",
          keyName: "regcapcur",
        },
        {
          title: "注册号：",
          keyName: "regno",
        },
        {
          title: "省份：",
          keyName: "regorgprovince",
        },
        {
          title: "查询人姓名：",
          keyName: "ryname",
        },
      ],
      "rypos_2": [
        {
          title: "出资方式",
          keyName: "conform",
        },
        {
          title: "统一社会信用代码",
          keyName: "creditcode",
        },
        {
          title: "认缴出资币种",
          keyName: "currency",
        },
        {
          title: "企业(机构)名称",
          keyName: "entname",
        },
        {
          title: "企业状态",
          keyName: "entstatus",
        },
        {
          title: "企业(机构)类型",
          keyName: "enttype",
        },
        {
          title: "成立时间",
          keyName: "esdate",
        },
        {
          title: "出资比例",
          keyName: "fundedratio",
        },
        {
          title: "行业名称",
          keyName: "industryphyname",
        },
        {
          title: "个人标识码",
          keyName: "palgorithmid",
        },
        {
          title: "注册资本(万元)",
          keyName: "regcap",
        },
        {
          title: "注册资本币种",
          keyName: "regcapcur",
        },
        {
          title: "注册号",
          keyName: "regno",
        },
        {
          title: "省份",
          keyName: "regorgprovince",
        },
        {
          title: "查询人姓名",
          keyName: "ryname",
        },
        {
          title: "认缴出资额(万元)",
          keyName: "subconam",
        },
      ]
    }
    const { ryposfrs = [], rypospers = [], ryposshas = [] } = data ;
    const datalist = [
      {
        datainfo: ryposfrs,
        title: "人员法人信息",
        datailItem: detailItems.rypos_1,
      },
      {
        datainfo: rypospers,
        title: "人员高管信息",
        datailItem: detailItems.rypos_1,
      },
      {
        datainfo: ryposshas,
        title: "人员股东信息",
        datailItem: detailItems.rypos_2,
      },
    ]
    return (
      <div className="shangye">
        {
          datalist.map((parentItem)=>{
            if(parentItem.datainfo.length === 0) return null ;
            return (
              <div>
                <h2>{parentItem.title}({ parentItem.datainfo.length }条）</h2>
                {
                  parentItem.datainfo.map((item)=>{
                    return (
                      <ul key={item.creditcode}>
                        {
                          parentItem.datailItem.map((data)=>{
                            return (
                              <li><em>{data.title}</em>{ item[data.keyName]}</li>
                            )
                          })
                        }
                      </ul>
                    )
                  })
                }
              </div>
            )
          })
        }
      </div>
    )
  }

  render(){
    const { data={} } = this.state;
    console.log(data);
    return (
      <div className="ResultDetails-wrap">
        <div className="container">
          <div className="top">
            <p className="title">详情</p>
            <button className="btn2" onClick={this.goBack}>返回</button>
          </div>
          <div className="content">
            {
              (()=>{
                switch (data.dataType) {
                  case "shixin":
                    return this.shixin(data) ;

                  case "cpws":
                    return this.cpws(data) ;

                  case "jinrong":
                    return this.renderJinRong(data.dataInfo) ;

                  case "shangye":
                    return this.renderShangYe(data.dataInfo) ;
                  
                  case "zgzs":
                    return this.renderZgzs(data.dataInfo) ;  

                  default:
                    return null ;
                }
              })()
            }
          </div>
        </div>
      </div>
    )
  }
  componentDidMount(){
    let params = JSON.parse(sessionStorage.getItem("params"));
    if(params.type === "newAjax") {

      getResultDetailNew(params).then((res)=>{
        this.setState({
          data: {
            dataType: params.dataType,
            dataInfo: res.resBody,
          }
        })
      }).catch(()=>{})
      return null
    } ;
    getResultDetail(params).then((data)=>{
      this.setState({
        data: data[params.dataType]
      })
    }).catch(()=>{})
  }
  goBack(){
    this.props.history.goBack();
  }
}

export default ResultDetail;